import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { switchMap, map, catchError, of } from "rxjs";
import { obterPaginaJornalPorAutenticidade, obterPaginaJornalPorAutenticidadeCatchError, obterPaginaJornalPorAutenticidadeFailure, obterPaginaJornalPorAutenticidadeSuccess } from "../../actions/Autenticidade/obter-pagina-jornal-por-autenticidade.action";
import { HttpErrorResponse } from "@angular/common/http";
import { EstruturaRetornoOutputDto } from "src/app/domain/DTOs/output/estrutura-retorno.output.dto";
import { AutenticidadeService } from "src/app/services/autenticidade.service";

@Injectable()
export class ObterPaginaJornalPorAutenticidadeEffects {

  public ObterPaginaJornalPorAutenticidade$: unknown;

  constructor(private actions$: Actions,
    private autenticidadeService: AutenticidadeService) {
    this.createEffects()
  }

  private createEffects() {
    this.ObterPaginaJornalPorAutenticidade$ = createEffect(() => this.actions$.pipe(
      ofType(obterPaginaJornalPorAutenticidade),
      switchMap(({ inputDto }) =>
        this.autenticidadeService
          .ObterPaginaJornalPorAutenticidade(inputDto)
          .pipe(
            map(
              response => {
                if (response.erros != undefined && response.erros.length > 0) {
                  return obterPaginaJornalPorAutenticidadeFailure({ response })
                }
                return obterPaginaJornalPorAutenticidadeSuccess({ response })
              }),
             catchError((error: HttpErrorResponse) => {
                const e = new EstruturaRetornoOutputDto(Object.values(error?.error?.errors))
                return of( obterPaginaJornalPorAutenticidadeCatchError({response: e}))
              }
            )
          )
      )
    )
    );
  }
}
